module.exports = __webpack_public_path__ + "static/images/smart-spot-shield.9a527a6794b86f09e1b834afabb7ddb6.svg";